function Home(){
    return(
        <div className="homepage_container">
            <div className="header">
                <h2>What is Anxiety and Me?</h2>
                <img className="image_container" src="https://post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/10/GettyImages-1173939468_header-1024x575.jpg" alt="" width="550px" height="350px"/>
                <p className="boxed">
                    
                    Anxiety and Me is a website created for understand and identifying anxiety in its many forms.
                    <br/>
                    <br/>
                    What is it that makes you anxious? It could something most would consider minor, maybe traffic on the way home. Or it could be something more difficult, such as a socially interacting.
                    <br/>
                    <br/>
                    We all experience anxiety. For example, speaking in front of a group can make us anxious, but that anxiety also motivates us to prepare and practice. Driving in heavy traffic is another common source of anxiety, but it helps keep us alert and cautious to avoid accidents. However, when feelings of intense fear and distress become overwhelming and prevent us from doing everyday activities, an anxiety disorder may be the cause.
                    <br/>
                    <br/>
                    Anxiety disorders are the most common mental health concern in the United States. Over 40 million adults in the U.S. (19.1%) have an anxiety disorder. Meanwhile, approximately 7% of children aged 3-17 experience issues with anxiety each year. Most people develop symptoms before age 21.
                    <br/>
                    <br/>
                
                </p>
            </div>
        </div>
   
    )
}

export default Home